import React from 'react';
// Session-Based Publication Opportunities and Conference Outcomes at {conference_name?conference_name:"[Conference Name]"}
const FourthStepTemplate = ({ values }) => {
  const {
    client_name,
    paper_title,
    conference_name,
    conference_date,
    conference_from_date,
    conference_to_date,
    conference_location,
    sdg_name_number,
    sdg_brif_explanation,
    registration_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>
        {client_name
          ? `Dear ${client_name},`
          : ` Dear [Client Name] / Dr. [Client Name],`}
      </p>

      <p>
        Greetings from <strong>IFERP!</strong>
      </p>

      <p>
        Your article titled "
        <strong>{paper_title ? paper_title : '[Paper Title]'}</strong>" has been
        accepted for presentation at{' '}
        <strong>
          {conference_name ? conference_name : '[Conference Name]'}
        </strong>
        , scheduled to take place on{' '}
        {/* <strong>{conference_date ? conference_date : '[Date]'}</strong> at{' '} */}
        <strong>{conference_from_date && conference_to_date
          ? `${conference_from_date} - ${conference_to_date}`
          : `[Conference from and to Date]`}</strong> at{' '}
        <strong>{conference_location ? conference_location : '[Venue]'}</strong>
        .
      </p>

      <p>
        <strong>Your Research and Its SDG Contributions:</strong>
      </p>
      <p>
        Your paper aligns with and contributes to the following United Nations
        Sustainable Development Goals (SDGs):
      </p>

      <p>
        <strong>
          {sdg_name_number ? sdg_name_number : '[SDG Name & Number]'}:
        </strong>{' '}
        {sdg_brif_explanation
          ? sdg_brif_explanation
          : '[Brief explanation]'}
        .
      </p>

      <p>
        The session in which your paper is featured is specifically designed to
        address these goals, fostering research and discussions that promote
        sustainable solutions and innovations for a brighter future.
      </p>

      <p>
        <strong>Join Us in Making a Difference:</strong>
      </p>
      <p>
        We are confident that your presentation will significantly contribute to
        the session’s objectives and the overall advancement of the SDGs
      </p>

      <p>
        Register Now:{' '}
        {registration_link ? (
          <a href={registration_link}>Click Here</a>
        ) : (
          '[Insert Registration Link]'
        )}
      </p>

      <p>
        Thank you for your valuable contribution to research and global
        development. We look forward to welcoming you to the conference and
        seeing the positive impact of your work.
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default FourthStepTemplate;
